import { isName } from '@/common/reg'

export default {
  // RULE: 证件类型
  legalIdCardType: () => [{ required: true, message: '请选择证件类型' }],

  // RULE: 证件号码
  legalIdCardCode: (idReg) => [{
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error('请填写证件号码'))
      if (value && !idReg().test(value)) callback(new Error('证件号不正确，请填写正确的证件号'))
      else callback()
    }
  }],

  // RULE: 证件姓名
  legalIdCardName: () => [
    { min: 2, max: 30, message: '证件名称2-30个字符', trigger: 'blur' },
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请填写姓名'))
        if (value && !isName.test(value)) callback(new Error('正确输入姓名，不能包含特殊字符'))
        else callback()
      }
    }
  ],

  // RULE: 证件到期时间 - 开始时间
  legalIdCardExpireDateStart: () => [{
    required: true,
    message: '请选择日期',
    trigger: 'change'
  }],

  // RULE: 证件到期时间 - 结束时间
  legalIdCardExpireDateEnd: () => [{
    required: true,
    message: '请选择日期',
    trigger: 'change'
  }],

  // RULE: 身份证正面
  legalIdCardFrontObjectId: () => [{
    required: true,
    trigger: '',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error('请上传身份证正面'))
      else callback()
    }
  }],

  // RULE: 身份证反面
  legalIdCardBackObjectId: () => [{
    required: true,
    trigger: '',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error('请上传身份证反面'))
      else callback()
    }
  }]
}
